const deps = function (id, objects) {
  const result = {}
  const object = objects[id]

  if (object) {
    result[id] = object.deps || []
    result[id].forEach((did) => {
      Object.assign(result, deps(did, objects))
    })
  }
  return result
}

export default deps
